const modes = {
  VIEW: 1,
  SELECT: 2
}

class Action {
  constructor (context, title, visibleFunc, runFunc) {
    this.context = context
    this.title = title
    this.visibleFunc = visibleFunc || (() => true)
    this.runFunc = runFunc || (() => {})
  }
  caption () {
    return this.title
  }
  isVisible () {
    return this.visibleFunc()
  }
  run () {
    return this.runFunc()
  }
}

class FilterAction extends Action {
  constructor (context) {
    super(context,
      'Фильтр...',
      () => !this.context.filterMode,
      () => { this.context.filterMode = true }
      )
  }
}

class FilterEndAction extends Action {
  constructor (context) {
    super(context,
      'Убрать фильтр',
      () => this.context.filterMode,
      () => {
        this.context.filterMode = false
        this.context.filterString = null
      })
  }
}

class ActiveScopeAction extends Action {
  constructor (context) {
    super(context, 'Активные')
  }
}

class AllScopeAction extends Action {
  constructor (context) {
    super(context, 'Все',
      null,
      () => {
        this.context.showAll()
      })
  }
}

class SelectAction extends Action {
  constructor (context) {
    super(context,
      'Операции',
      null,
      () => {
        this.context.mode = modes.SELECT
      }
    )
  }
}

class SelectEndAction extends Action {
  constructor (context) {
    super(context,
      'Отмена',
      null,
      () => {
        this.context.mode = modes.VIEW
        this.context.clear()
      }
    )
  }
}

class SelectAllAction extends Action {
  constructor (context) {
    super(context,
      'Выбрать Всех',
      null,
      () => this.context.checkAll()
    )
  }
}

class ClearAllAction extends Action {
  constructor (context) {
    super(context,
      'Очистить',
      null,
      () => this.context.clear()
    )
  }
}

class MultiSelectContext {
  constructor (allItemsIdF) {
    this.allItemsIdF = allItemsIdF
    this.filterMode = false
    this.filterString = null
    this.mode = modes.VIEW
    this.activeId = null
    this.selectedIds = []
    this.actions = []
    this.actionIcon = 'more_vert'
    this.selectActions = []
    this.title = 'Просмотр'
    this.titleIcon = null
    this.selectTitle = 'Выбор'
    this.selectTitleIcon = null
  }
  activate (uid) {
    this.activeId = uid
  }
  activated (uid) {
    return this.activeId === uid
  }
  select (uid) {
    this.activate(uid)
    if (this.isSelectMode()) {
      if (!this.check(uid)) {
        this.selectedIds.push(uid)
      } else {
        this.selectedIds = this.selectedIds.filter(i => i !== uid)
      }
    }
  }
  uncheck (uid) {
    return this.isSelectMode() && !this.selectedIds.includes(uid)
  }
  check (uid) {
    return this.isSelectMode() && this.selectedIds.includes(uid)
  }
  clear () {
    this.selectedIds = []
  }
  checkAll () {
    this.selectedIds = this.allItemsIdF()
  }
  showAll () {
    this.mode = modes.VIEW
    this.clear()
    this.filterString = null
  }
  selected () {
    return this.selectedIds
  }
  setSelected (uids) {
    this.selectedIds = uids || []
  }
  selectedCount () {
    return this.selectedIds.length
  }
  isSelectMode () {
    return this.mode === modes.SELECT
  }
  isFilterMode () {
    return this.filterMode
  }
  getTitle () {
    return this.isSelectMode() ? this.selectTitle : this.title
  }
  getTitleIcon () {
    return this.isSelectMode() && this.selectTitleIcon ? this.selectTitleIcon : this.titleIcon
  }
  getActions () {
    return this.isSelectMode() ? this.selectActions : this.actions
  }
  toViewMode () {
    if (this.isSelectMode()) {
      this.clear()
      this.mode = modes.VIEW
    }
  }
}

export default {
  modes,
  Action,
  FilterAction,
  FilterEndAction,
  ActiveScopeAction,
  AllScopeAction,
  SelectAction,
  SelectEndAction,
  SelectAllAction,
  ClearAllAction,
  MultiSelectContext
}



// WEBPACK FOOTER //
// ./src/api/classes.js